<div class="device-payment-dialog">
  <div class="device-payment-dialog__header">
    <h2>{{description}}</h2>
  </div>

  <div class="device-payment-dialog__body">
    <!-- Material icon instead of broken image -->
    <div class="device-payment-dialog__icon-wrap" *ngIf="!imgSrc">
      <i class="material-icons device-payment-dialog__icon">tap_and_play</i>
    </div>
    <img *ngIf="imgSrc" class="device-payment-dialog__image" [src]="imgSrc" alt=""/>

    <p class="device-payment-dialog__message" *ngIf="message">{{message}}</p>

    <div class="device-payment-dialog__device-name" *ngIf="deviceName">
      <i class="material-icons">devices</i>
      <span>{{deviceName}}</span>
    </div>

    <div class="device-payment-dialog__split-progress" *ngIf="splitProgress">
      <span class="device-payment-dialog__split-label">
        Person {{ splitProgress.current }} of {{ splitProgress.total }}
      </span>
      <span class="device-payment-dialog__split-amount">
        Charging ${{ (splitProgress.amountCents / 100).toFixed(2) }}
      </span>
    </div>

    <div class="device-payment-dialog__status">
      <span>Sending Payment to Device</span>
      <span class="device-payment-dialog__timer" *ngIf="time > 0">{{time}}s</span>
    </div>

    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div class="device-payment-dialog__actions">
    <button class="device-payment-dialog__btn device-payment-dialog__btn--retry"
            *ngIf="time === 0"
            [disabled]="retryPaymentDisabled"
            (click)="resendPaymentToDevice()">
      <i class="material-icons">refresh</i> {{ getTimerValue() }}
    </button>
    <button class="device-payment-dialog__btn device-payment-dialog__btn--cancel"
            (click)="closeAndCancelOrder()">
      <i class="material-icons">close</i>
      {{ selectedRole === Constants.KIOSK ? 'Cancel Order' : 'Cancel' }}
    </button>
  </div>
</div>
